Namespace 'App.HierarchicalSelect'

class App.HierarchicalSelect.CrossWrapperView extends Backbone.View
  template: JST['backbone/templates/monitoring/select/hierarchical/cross_wrapper']

  defaults:
    children: ''
    showCross: false

  events:
    'click #remove': '_onRemove'

  initialize: ({children, showCross}) ->
    @children = children || @defaults.children
    @showCross = showCross || @defaults.showCross

  render: =>
    @$el.html(@template(showCross: @showCross))
    @$el.find('#children').html(@children)
    @

  _onRemove: =>
    @trigger('remove')
